interface HeadlineProps {
  children: React.ReactNode
}

export function Headline(props: HeadlineProps) {
  return (
    <h2 className="text-muted-foreground text-3xl leading-tight font-bold tracking-tighter md:text-5xl lg:leading-[1.1]">
      <span className={`
        w-fit bg-linear-to-br from-zinc-400 from-5% to-zinc-900 bg-clip-text pr-0.5 text-3xl leading-tight font-bold
        tracking-tighter text-transparent
        md:text-5xl
        lg:leading-[1.1]
      `}
      >
        {props.children}
      </span>
    </h2>
  )
}
